import React, { useEffect, useState } from 'react';
import { NavLink, useHistory, withRouter } from "react-router-dom";
import { connect } from "react-redux";

import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import Params from '../services/Params';

const MenuItem = ({ icon, text, onClick, link, alert }) => {
	const [searchParams, setSearchParams] = useState();
	const history = useHistory();

	useEffect(() => {
		setSearchParams(history.location.search);
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	history.listen(() => {
		setSearchParams(history.location.search)
	})

	return (
		<NavLink exact={true} to={{ pathname: link, search: searchParams }} className="wrap" activeClassName="is-active" onClick={onClick}>
			<div className="icon">
				{alert ? (
					<span className="alert-icon-box">
						{icon}
						<span className="_notification-icon-mark _red"></span>
					</span>
				) :
					<>
						{icon}
					</>
				}
			</div>
			<div className="text">
				{text}
			</div>
		</NavLink>
	)
}

function FixedMenu({website}) {

	const [fixedMenuParams, setFixedMenuParams] = useState();

	useEffect(() => {

		const param = new Params();

		param.findParam('fixed_menu').then((response) => {
			if(response.data && response.data.type === 'success') {
				setFixedMenuParams(response.data.payload);
			}
		})

	}, [])
	
	return (
		<>
			{fixedMenuParams && fixedMenuParams.mostrar_menu? 
				(<div id="fixed-menu" className={`fixed-menu-${website}`}>
					{fixedMenuParams.menu_home? (<MenuItem link="/" icon={<Icon icon={["far", "home-alt"]} />} text="Home" />): (<></>)}
					{fixedMenuParams.menu_ofertas? (<MenuItem link="/ofertas" icon={<Icon icon={["far", "tags"]} />} text="Ofertas" />): (<></>)}
					{fixedMenuParams.menu_parceiros? (<MenuItem link="/parceiros" icon={<Icon icon={["far", "store"]} />} text="Parceiros" />): (<></>)}
					{fixedMenuParams.menu_sidemenu? (<MenuItem link="/user-menu" icon={<Icon icon={["far", "ellipsis-h"]} />} text="Mais" />): (<></>)}
				</div>) : (<></>)
			}
			

		</>
	)
}

const mapStateToProps = (state) => {
	return {
		website: state.websiteReducer.website
	};
};

export default withRouter(connect(mapStateToProps)(FixedMenu));
